// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `Układ o tej nazwie już istnieje`,
    ACCEPT: `Akceptuj`,
    ACCEPT_ALL: `Zaakceptuj wszystko`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Zatwierdzenie`,
    ACCEPTED: `Zaakceptowano`,
    ACCOUNT: `Konto`,
    ACCOUNT_ADDRESS: `Adres konta`,
    ACCOUNT_COUNTRY: `Kraj przypisany do konta`,
    ACCOUNT_END: `Koniec konta`,
    ACCOUNT_NAME: `Nazwa konta`,
    ACCOUNT_NUMBER: `Numer konta`,
    ACCOUNT_NUMBER_REQUIRED: `Wymagany jest numer konta`,
    ACCOUNTS: `Konta`,
    ACCUMULATED_DAYS_ON_RENT: `Suma dni wynajmu`,
    ACCUMULATED_DAYS_RENTED: `Suma dni wypożyczenia`,
    ACTIONS: `Działania`,
    ACTIVE_WARRANTY: `Aktywna gwarancja`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `Ważna gwarancja (kliknij, aby uzyskać szczegóły)`,
    ACTIVE_WARRANTY_Y_N: `Aktywna gwarancja (T/N)`,
    ACTUAL_AMOUNT_OF_USE: `Rzeczywista intensywność użytkowania`,
    ACTUAL_AUDIT: `Rzeczywisty audyt`,
    ACTUAL_AUDIT_DATE: `Rzeczywista data audytu`,
    ACTUAL_COURIER_NAME: `Aktualna nazwa przewoźnika`,
    ACTUAL_H: `Aktualne godziny`,
    ACTUAL_HOURS: `Aktualne godziny`,
    ACTUAL_PC:`Rzeczywiste bele`,
    ADD_CLAIM: `Dodaj roszczenie`,
    ADD_CLAIMS: `Dodaj roszczenia`,
    ADD_COMPONENT: `Dodaj komponent`,
    ADD_OPTION: `Dodaj opcje`,
    ADD_REP: `Dodatkowa naprawa`,
    ADD_TO_AUDIT: `Dodaj do audytu`,
    ADDITIONAL: `Dodatkowy`,
    ADDITIONAL_COMMENTS: `Uwagi dodatkowe`,
    ADDITIONAL_REPAIR: `Dodatkowa naprawa`,
    ADDITIVE: `Dodatek`,
    ADDRESS: `Adres`,
    ADDRESS_LINE1: `Wiersz adresu 1`,
    ADDRESS_LINE1_REQUIRED: `Wymagany wiersz adresu 1`,
    ADDRESS_LINE2: `Wiersz adresu 2`,
    ADJ_CLM: `Dostosuj roszczenie`,
    ADJUST_CLAIM: `Dostosuj roszczenie`,
    ADJUSTED_HOURS: `Liczba godzin`,
    ADJUSTED_QUANTITY: `Dostosowana ilość`,
    ADJUSTMENT_TYPE: `Typ regulacji`,
    ADVANCED_CLAIM_SUMMARY: `Zaawansowane Podsumowanie reklamacji`,
    AFTER_DELIVERY_INSPECTION: `KONTROLA PO DOSTAWIE`,
    AGENCY_NAME: `Nazwa agencji`,
    ALL: `Wszystko`,
    ALL_ACCOUNTS: `Wszystkie konta`,
    ALL_CLAIMS: `Wszystkie reklamacje`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `Wszystkie reklamacje podlegają przeglądowi (patrz JD WAM 110.08 w celu uzyskania dalszych informacji)`,
    ALL_CLAIMS_TAB: `Wszystkie roszczenia ({count, number})`,
    ALL_PART_REQUESTS: `Wszystkie wnioski o części`,
    ALL_PART_REQUESTS_WITH_COUNT: `Wszystkie wnioski o części ({count})`,
    ALL_PARTS_RETURNED: `Zwrócono wszystkie części`,
    AMOUNT: `Ilość`,
    AMOUNT_1: `Ilość 1`,
    AMOUNT_2: `Ilość 2`,
    AMOUNT_3: `Ilość 3`,
    AMOUNT_OF_USE: `Czas Użytkowania`,
    AMOUNT_OF_USE_ACCEPETD: `Zaakceptowana wielkość użycia`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Stopień wykorzystania utworzony pomyślnie`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `Historia czasu wykorzystania ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `Wymagane jest podanie czasu użytkowania`,
    AMOUNT_OF_USE_REJECTED: `Odrzucono stopień wykorzystania`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Stan liczby żądań użycia`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Liczba żądań użycia ({count})`,
    AMOUNT_OF_USE_REQUIRED: `Wymagany czas użytkowania`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `Wymagane jednostki czasu użytkowania`,
    AMOUNT_RECORDED: `Zapisano czas`,
    AMOUNT_TO_BE_DEBITED: `Kwota do obciążenia`,
    APLYPIP: `Zastosuj PIP`,
    APPLICATION: `Zastosowanie`,
    APPLICATION_IS_REQUIRED: `Wymagane jest podanie zastosowania`,
    APPLY: `Zastosuj`,
    APPLY_TRAVEL: `Dostosuj podróż`,
    APPROVAL_DEALER_COMMENTS: `Uwagi dealera zatwierdzającego`,
    APPROVAL_DETAILS: `Szczegóły zatwierdzenia`,
    APPROVAL_LEVELS: `Poziom zatwierdzenia`,
    APPROVAL_REMARKS: `Uwagi dotyczące zatwierdzenia`,
    APPROVAL_STATUS: `Stan zatwierdzenia`,
    APPROVE: `Zatwierdź`,
    APPROVE_AMOUNT_OF_USE: `Zatwierdź stopień wykorzystania`,
    APPROVE_LABOR_RATE: `Zatwierdzona stawka robocza`,
    APPROVE_MACHINE_STATUS_UPDATE: `Zatwierdź aktualizację stanu maszyny`,
    APPROVE_PIP_CODE_REQUEST: `Zatwierdź wniosek o kod PIP`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `Zatwierdź roszczenie dotyczące przydziału specjalnego`,
    APPROVED: `ZATWIERDZONO`,
    APPROVED_CORE_VALUE: `Zatwierdzona wartość Core`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `Data zatwierdzenia nie może być wcześniejsza niż data ustawienia`,
    APPROVED_DIAGNOSTIC_AMOUNT: `Zatwierdzona kwota diagnostyczna`,
    APPROVED_DIAGNOSTIC_HOURS: `Zatwierdzone godziny diagnostyczne`,
    APPROVED_IS_REQUIRED: `Wymagane jest wypełnienie pola zatwierdzenia`,
    APPROVED_LABOR_ADDITIVE: `Zatwierdzony koszt pracy`,
    APPROVED_LABOR_AMOUNT: `Zatwierdzona wartość pracy`,
    APPROVED_LABOR_HOURS: `Zatwierdzone godziny pracy`,
    APPROVED_LABOR_TOTAL: `Całkowita liczba zaakceptowanej pracy`,
    APPROVED_ON_SHELF_COST: `Zatwierdzone dla kosztów magazynowania`,
    APPROVED_OTHER_CREDITS: `Zatwierdzone inne kredyty`,
    APPROVED_PARTS: `Zatwierdzone części`,
    APPROVED_PARTS_ADDITIVE: `Zatwierdzony koszt dodatkowy części`,
    APPROVED_PARTS_TOTAL: `Całkowita liczba zaakceptowanych części`,
    APPROVED_REJECTED: `Zatwierdzono/odrzucono`,
    APPROVED_REPAIR_AMOUNT: `Zatwierdzona kwota naprawy`,
    APPROVED_REPAIR_HOURS: `Zatwierdzone godziny naprawy`,
    APPROVED_TAXES_TOTAL: `Całkowita suma zatwierdzonych obciążeń podatkowych`,
    APPROVED_TRAVEL_TOTAL: `Całkowita liczba zaakceptowanych podróży`,
    APPROVER: `Osoba zatwierdzająca`,
    ASCENDING: `kolejności rosnącej`,
    ATTACHMENTS: `Załączniki`,
    AUDIT_NUMBER: `Numer audytu`,
    AUDIT_PLANNED: `Planowany audyt`,
    AUDIT_REQUIREMENT: `Wymóg audytu`,
    AUDIT_RESULTS: `Rezultaty audytu`,
    AUDIT_STATUS: `Status audytu`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `Audyt został pomyślnie przesłany`,
    AUDIT_SUMMARY: `Podsumowanie audytu`,
    AUDIT_TYPE: `Typ audytu`,
    AUDITS: `Audyty`,
    AUDITS_DUE_WITH_COUNT: `Liczba zbliżających się audytów {countToDisplay}`,
    AUDITS_DUE_WITHIN_30_DAYS: `W ciągu najbliższych 30 dni odbędzie się następująca liczba audytów {countToDisplay} {count, plural, one {audyt} other {audytów}}`,
    AUDITS_PAST_DUE_WITH_COUNT: `Liczba audytów po terminie {countToDisplay} {count, plural, one {audyt} other {audytów}}`,
    AUTHORIZATION_NUMBER: `Numer autoryzacji`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `Automatycznie wyślij z biznesowego systemu dealerów`,
    AVAILABLE: `DOSTĘPNE`,
    AVAILABLE_COLUMNS: `Dostępne Kolumny`,
    AVERAGE_DIAGNOSTICS_HOURS: `Średnia liczba godzin diagnostycznych`,
    AVERAGE_LUG_HEIGHT: `Średnia wysokość uchwytu`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `Wymagana jest średnia wysokość uchwytu`,
    AVERAGE_REPAIR_HOURS: `Średnia liczba godzin naprawy`,
    AVERAGE_REPLACEMENT_HOURS: `Średnia liczba godzin wymiany`,
    AVERAGE_TECH_PAY_RATE: `Średnia stawka robocza pracowników technicznych`,
    BACK: `Wstecz`,
    BACK_TO_AUDIT: `Powrót do audytu`,
    BASE_MACHINE: `Podstawowa maszyna`,
    BASE_MACHINE_IMPLEMENTS: `Sprzęt maszyny podstawowej`,
    BASE_MACHINE_PIN: `PIN maszyny podstawowej`,
    BASIC_WARRANTY_ENDS: `Koniec podstawowej gwarancji`,
    BASIC_WARRANTY_ESTIMATOR: `Podstawowy estymator gwarancji`,
    BASIC_WARRANTY_STARTS: `Początek podstawowej gwarancji`,
    BASIS_FOR_SETTLEMENT: `Podstawa do rozliczenia`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Podstawa do rozliczenia / Uwagi do audytu`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `Wymagana jest podstawa do rozliczenia`,
    BATTERY: `BATERIA`,
    BEGIN_DATE: `Data początkowa`,
    BRANCH: `Oddział`,
    BUILT: `Skonstruowano`,
    BUSINESS_END: `Zakończenie działalności`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE:`Czy maszyna może zostać ponownie uruchomiona?`,
    CANCEL: `Anuluj`,
    CERTIFIED_LETTER_SENT: `Wysłano list potwierdzony`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `Zmień odpowiedzialnego dealera`,
    CHANGE_STATUS: `Zmień stan`,
    CHANGE_STATUS_FOR: `Zmień status na {pin}`,
    CHANGED: `Zmieniony`,
    CHANGED_BY: `Zmienione przez`,
    CHANGED_ON: `Zmieniane w`,
    CHINESE: `Chiński`,
    CITY: `Miasto`,
    CITY_REQUIRED: `Wymagane miasto`,
    CLAIM: `Roszczenie`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {Roszczenie} other {Roszczenie}})`,
    CLAIM_DEBIT: `Obciążenie roszczenia`,
    CLAIM_DETAILS: `Szczegóły reklamacji`,
    CLAIM_DRAFT: `WERSJA ROBOCZA`,
    CLAIM_HISTORY: `24 miesięczna historia żądania`,
    CLAIM_HISTORY_WITH_COUNT: `24 miesięczna historia żądania ({count})`,
    CLAIM_NUMBER: `Numer reklamacji`,
    CLAIM_RECOVER_PERCENTAGE: `({percentage}%)`,
    CLAIM_SEARCH: `Wyszukiwanie reklamacji`,
    CLAIM_STATUS: `Status roszczenia`,
    CLAIM_TYPE: `Rodzaj reklamacji`,
    CLAIM_TYPES: `Rodzaje roszczeń`,
    CLAIM_UPDATED_SUCCESSFULLY: `Roszczenie zaktualizowano pomyślnie`,
    CLAIM_VALUE: `Wartość reklamacji`,
    CLAIM_VALUE_DETAILS: `Szczegóły dotyczące wartości roszczenia`,
    CLAIM_WITH_NUMBER: `Roszczenie {claimNumber}`,
    CLAIMS: `Reklamacje`,
    CLAIMS_IN_PROGRESS: `Roszczenia w toku`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `Roszczenia w toku ({count})`,
    CLAIMS_OVERVIEW: `Podsumowanie roszczeń`,
    CLAIMS_OVERVIEW_TAB: `Podsumowanie roszczeń ({count})`,
    CLAIMS_WITH_COUNT: `Liczba roszczeń {count}`,
    CLICK_FOR_DETAILS: `(Kliknij, aby wyświetlić szczegóły)`,
    CLICK_TO_VIEW_ALL: `Kliknij, aby wyświetlić wszystko`,
    CLOSE: `Zamknij`,
    CLOSED_PART_REQUESTS: `Zamknięte żądania części`,
    CLOSING: `Zakończenie`,
    CLOSING_ACCOUNT: `Konto końcowe`,
    CLOSING_ACCOUNT_WITH_COUNT: `Konto końcowe ({count})`,
    CODE: `Kod`,
    COLLAPSE_ALL: `Zwiń wszystko`,
    COMMENT: `Uwaga`,
    COMMENTS: `Uwagi`,
    COMMENTS_IS_REQUIRED: `Wymagane są komentarze`,
    COMMENTS_TO_DEALER: `Komentarze dla dealera`,
    COMMON_LABOR_TYPES_WARNING: `Nie wszystkie rodzaje pracy dostępne dla wybranych kont`,
    COMPANY: `Firma`,
    COMPANY_CONTRIBUTION: `Wkład firmy`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `Wymagane jest podanie wkładu firmy`,
    COMPLAINT_CAUSE: `Jaka była diagnostyka zgłoszonego problemu?`,
    COMPLAINT_CAUSE_IS_REQUIRED: `Wymagana jest diagnostyka reklamacji`,
    COMPLAINT_CORRECTION: `W jaki sposób naprawiono reklamację?`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `Wymagana jest naprawa reklamacji`,
    COMPLETE: `Zakończone`,
    COMPLETED: `Ukończono`,
    COMPLETED_BY: `Uzupełniony przez`,
    COMPLETED_DATE: `Data ukończenia`,
    COMPLETED_IN_LAST_24_MONTHS: `Ukończone w ciągu ostatnich 24 miesięcy`,
    COMPLETION_STATUS: `Status ukończenia`,
    COMPONENT: `Podzespół`,
    COMPONENT_CODE: `Kod komponentu`,
    COMPONENT_CREATED_SUCCESSFULLY: `Komponent stworzony pomyślnie`,
    COMPONENT_DELETED_SUCCESSFULLY: `Komponent usunięty pomyślnie`,
    COMPONENT_SERIAL_NUMBER: `Numer seryjny komponentu`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Podzespół zaktualizowany pomyślnie`,
    COMPONENTS: `Komponenty`,
    CONFIRM: `Potwierdź`,
    CONFIRM_ADDITIONAL_REPAIR: `Czy na pewno chcesz dodać dodatkową naprawę?`,
    CONFIRM_ADJUST_CLAIM: `Czy na pewno chcesz dostosować to roszczenie?`,
    CONFIRM_CLOSING_ACCOUNT: `Czy na pewno chcesz zaakceptować to przeniesienie?`,
    CONFIRM_COPY_CLAIM: `Czy na pewno chcesz skopiować to roszczenie?`,
    CONFIRM_DELETE_ATTACHMENT: `Czy na pewno chcesz usunąć załączony plik?`,
    CONFIRM_DELETE_CLAIM: `Czy na pewno chcesz usunąć to roszczenie?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `Czy na pewno chcesz usunąć to żądanie stanu maszyny?`,
    CONFIRM_DELETE_REGISTRATION: `Czy na pewno chcesz usunąć tę rejestrację?`,
    CONFIRM_EDIT_CLAIM: `Czy na pewno chcesz edytować to roszczenie?`,
    CONFIRM_RECONCILE_CLAIM: `Czy na pewno chcesz uzgodnić to roszczenie?`,
    CONFIRM_RESEND_XML: `Czy na pewno chcesz ponownie wysłać plik XML? Należy odczekać 24-48 godzin, aż będzie widoczny.`,
    CONFIRM_SKIP_AUDIT: `Czy na pewno chcesz pominąć ten audyt?`,
    CONFIRM_UNDO_REGISTRATION: `Czy na pewno chcesz cofnąć tę rejestrację?`,
    CONFIRM_UNRECONCILE_CLAIM: `Czy na pewno chcesz anulować uzgodnienie tego roszczenia?`,
    CONNECTED_MACHINE: `Maszyna podłączona`,
    CONTACTED: `Skontaktowano`,
    CONTAINS: `Zawiera`,
    CONTRACT_NUMBER: `Numer umowy`,
    CONTRACT_PURCHASED: `Zawarta umowa`,
    CONTRACT_TYPE: `Rodzaj umowy`,
    COPY_CLAIM: `Kopiuj reklamację`,
    CORE: `Podstawa`,
    CORE_VALUE: `Najważniejsza wartość`,
    COUNTRY: `Kraj`,
    COUNTRY_REQUIRED: `Wymagany kraj`,
    COURIER_ACCOUNT_NUMBER: `Numer konta przewoźnika`,
    COURIER_NAME: `Nazwa przewoźnika`,
    COVERAGE_DECISION: `Decyzja w sprawie pokrycia`,
    COVERAGE_TYPE: `Typ pokrycia`,
    CRDMEM: `Faktura korygująca`,
    CREATE: `Utwórz`,
    CREATE_CLAIM: `Utwórz reklamację`,
    CREATE_LAYOUT: `Utwórz Układ`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `Przed złożeniem roszczenia dotyczącego tego produktu przekaż nam kilka istotnych informacji`,
    CREATE_PIP_CLAIM: `Utwórz roszczenie PIP`,
    CREATE_PIP_CLAIMS: `Utwórz roszczenia PIP`,
    CREATE_PRODUCT_RECORD: `Utwórz wpis w rejestrze dotyczący produktu`,
    CREATE_REQUEST: `Utwórz żądanie`,
    CREATE_TRANSFER_PENDING: `Transfer w toku`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `Funkcja utworzenia usługi transferu niedostępna`,
    CREATED: `Utworzono`,
    CREATED_BY: `Utworzony przez`,
    CREATED_DATE: `Data utworzenia`,
    CREATED_DATE_FROM: `Od daty utworzenia`,
    CREATED_DATE_TO: `Do daty utworzenia`,
    CREATED_ON: `Utworzono`,
    CREATION_DATE: `Data utworzenia`,
    CREDIT_MEMO: `Nota kredytowa`,
    CREDIT_MEMO_DATE: `Data noty kredytowej`,
    CREDIT_MEMO_ISSUE_DATE: `Wydanie faktury korygującej`,
    CREDIT_MEMO_NUMBER: `Numer faktury korygującej`,
    CREDIT_MEMO_PROCESS_DATE: `Przetwarzanie faktury korygującej`,
    CREDIT_MEMO_SELECTED: `Wybrana nota kredytowa`,
    CREDIT_MEMOS: `Noty kredytowa`,
    CRITERIA: `Kryteria`,
    CRT: `Utwórz`,
    CSV_SEPARATOR: `Separator CSV`,
    CURRENCY: `Waluta`,
    CURRENT: `Aktualny`,
    CURRENT_ACCOUNT: `Aktualne konto`,
    CURRENT_AMOUNT_OF_USE: `Aktualny Czas Użytkowania`,
    CURRENT_CUSTOMER: `Bieżący klient`,
    CURRENT_DEALER: `Obecny dealer`,
    CURRENT_DEALER_DISTANCE: `Bieżąca odległość dealera`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Bieżąca data ostatniej usługi dla dealera`,
    CURRENT_DEALER_LOCATION: `Obecny client`,
    CURRENT_HOURS: `Bieżące godziny`,
    CURRENT_QUANTITY: `Bieżąca ilość`,
    CURRENT_RESPONSIBLE_DEALER: `Bieżący odpowiedzialny sprzedawca`,
    CURRENT_VALUES: `Bieżące wartości`,
    CURRENTLY_ON_RENT: `Obecnie wynajęte`,
    CUSTOM_RANGE: `Zakres niestandardowy`,
    CUSTOM_VALUES: `Wartości klienta`,
    CUSTOMER: `Klient`,
    CUSTOMER_CONTRIBUTION: `Wkład klienta`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `Wymagane jest podanie wkładu klienta`,
    CUSTOMER_CREATED_SUCCESSFULLY: `Pomyślnie utworzono profil klienta`,
    CUSTOMER_DETAILS: `Dane klienta`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `Pomyślnie zaktualizowano szczegóły dotyczące klienta`,
    CUSTOMER_INFORMATION: `Informacje dla klientów`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `Wymagane są informacje o klientach.`,
    CUSTOMER_INVALID: `Nieprawidłowy klient`,
    CUSTOMER_NAME: `Nazwa klienta`,
    CUSTOMER_NAME_IS_REQUIRED: `Wymagane są informacje o klientach.`,
    CUSTOMER_NOT_FOUND: `Nie znaleziono klienta`,
    CUSTOMER_REQUIRED: `Klient wymagany`,
    CUSTOMER_RESOLUTION: `Rozwiązanie dla klienta`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `Wymagane jest podanie rozwiązania dla klienta`,
    CUSTOMER_SEARCH: `Wyszukiwanie klienta`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `Pomyślnie zaktualizowano profil klienta`,
    DAMAGED_MACHINES_HELP_TEXT:`W przypadku uszkodzonych maszyn gwarancja zostanie automatycznie zawieszona do czasu przejrzenia i zatwierdzenia niniejszego formularza przez technika TCSM w celu przywrócenia gwarancji. Uszkodzone maszyny kwalifikują się wyłącznie do obowiązkowych PIP i zabezpieczeń.`,
    DATE: `Data`,
    DATE_FORMAT: `Format daty`,
    DATE_ISSUED: `Data wydania`,
    DATE_OF_CERTIFIED_LETTER: `Data nadania listu potwierdzonego`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`Data zdarzenia powodującego szkodę`,
    DATE_OF_LAST_PERSONAL_CONTACT: `Data ostatniego kontaktu osobistego`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `Data transportu/wysłania wspomnianej części`,
    DATE_REFUSED: `Data odrzucona`,
    DATE_SUBMITTED: `Data przesłania`,
    DAYS_FROM_REGISTRATION: `Liczba dni od rejestracji`,
    DAYS_LEFT: `Pozostałe dni`,
    DAYS_LEFT_WITH_COUNT: `{daysToDisplay} {days, plural, one {dzień} other {dni}}`,
    DAYS_ON_RENT: `Dni wynajęcia`,
    DAYS_REMAINING: `Pozostało dni`,
    DAYS_REMAINING_WITH_COUNT: `Pozostało {daysToDisplay} {days, plural, one {dzień} other {dni}}`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {dzień} other {dni}} Od zalecenia`,
    DAYS_TO_DISPLAY: `Liczba dni do wyświetlenia`,
    DBS: `DBS`,
    DEALER: `Dealer`,
    DEALER_ACCOUNT: `Konto dealera`,
    DEALER_ACCOUNT_IS_REQUIRED: `Wymagane jest podanie konta dealera`,
    DEALER_ACCOUNTS: `Konta dealera`,
    DEALER_CITY: `Miasto dealera`,
    DEALER_COMMENTS: `Uwagi dealera`,
    DEALER_CONTRIBUTION: `Wkład dealera`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `Wymagane jest podanie wkładu dealera`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `Numer faktury dla dealera`,
    DEALER_INVOICE_UPDATED: `FAKTURA PRZEDSTAWICIELA ZAKTUALIZOWANA`,
    DEALER_INVOICE_UPDATES: `Faktura dealera`,
    DEALER_INVOICES: `Faktury dealera`,
    DEALER_LOCATION: `Lokalizacja dealera`,
    DEALER_LOCATION_FILTER: `Filtruj lokalizacje`,
    DEALER_LOCATION_IS_REQUIRED: `Wymagana jest lokalizacja dealera`,
    DEALER_LOCATIONS: `Lokalizacje dealerów`,
    DEALER_NAME: `Nazwa dealera`,
    DEALER_PHONE: `Nr telefonu dealera`,
    DEALER_POSTAL_CODE: `Kod pocztowy`,
    DEALER_RECOMMENDATIONS: `Zalecenia dla dealerów`,
    DEALER_RECOMMENDATIONS_TAB: `Zalecenia dla dealerów ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Sprzedawca został pomyślnie przejrzany`,
    DEALER_SEARCH: `Wyszukiwanie dealera`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `Aby wyszukać dealerów, wpisz nazwę miasta lub konta`,
    DEALER_STATE: `Stan deleara/prowincja`,
    DEALER_SUBMISSION_WITH_CURRENCY: `Wartość zgłoszenia do dealera ({currency})`,
    DEALER_TRANSFER_HISTORY: `Historia przeniesienia dealera`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Niektóre żądania transferu zostały utworzone pomyślnie. Proces pozostały osobno.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Żądanie transferu dealera zostało pomyślnie umieszczone w kolejce`,
    DEALER_WARRANTY: `Gwarancja dealera`,
    DEALERS: `Dealerzy`,
    DEALERSHIP: `Salon dealerski`,
    DEBIT: `Obciążenie`,
    DEBIT_AMOUNT: `Kwota obciążenia`,
    DEBIT_FOR_CLAIM_NUMBER: `Obciążenie roszczenia {claimNumber}`,
    DEBIT_REQUIRED: `Żądanie obciążenia`,
    DEBIT_REQUIRED_STATUS: `Status wymaganego obciążenia`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `Wartość obciążenia została przesłana`,
    DEBIT_TYPE: `Typ debetu`,
    DEBITED: `Spieniężone`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `Obciążenie niniejszego roszczenia musi być ukończone poprzez ręczne przetwarzanie obciążenia`,
    DECIMAL_FORMAT: `Format dziesiętny`,
    DECISION_UPDATED: `Decyzja zaktualizowana`,
    DECLINE: `Odrzuć`,
    DEDUCTIBLE: `Kwota potrącona`,
    DEERE_REMARKS: `Uwagi Deere`,
    DEFAULT_WARRANTY: `Gwarancja domyślna`,
    DEL: `Usuń`,
    DELETE: `Usuń`,
    DELETE_ATTACHMENT: `Usuń załącznik`,
    DELETE_CLAIM: `Usuń roszczenie`,
    DELETE_MACHINE_STATUS_UPDATE: `Usuń aktualizację stanu maszyny`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `Pomyślnie usunięto stan maszyny`,
    DELETE_REGISTRATION: `Usuń rejestrację`,
    DELETE_REGISTRATION_SUCCESS: `Usunięcie rejestracji powiodło się`,
    DELETED: `USUNIĘTO`,
    DELETED_BY: `Ununięto przez`,
    DELIVERED: `Dostarczono`,
    DELIVERED_IS_REQUIRED: `Wymagane jest wypełnienie pola dostarczenia`,
    DELIVERY_DATE: `Data dostawy`,
    DELIVERY_DATE_REQUIRED: `Wymagana data dostawy`,
    DELIVERY_DATES: `Daty dostaw`,
    DELIVERY_NO_DOCUMENTS: `Dostawa bez dokumentów`,
    DEMO_RENTAL_BEGIN_DATE: `Data rozpoczęcia wynajmu próbnego/wynajmu`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `Wybierz status i dealerów`,
    DEMO_RENTAL_END_DATE: `Data zakończenia wynajmu próbnego/wynajmu`,
    DEMO_RENTAL_HISTORY: `Historia wynajmu próbnego`,
    DENY: `Odrzuć`,
    DENY_AMOUNT_OF_USE: `Odmów stopnia wykorzystania`,
    DENY_MACHINE_STATUS_UPDATE: `Odrzuć aktualizację stanu maszyny`,
    DENY_PIP_CODE_REQUEST: `Odrzuć wniosek o kod PIP`,
    DESCENDING: `kolejności malejącej`,
    DESCRIPTION: `opis`,
    DESCRIPTION_OF_DAMAGE:`Opis uszkodzenia`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Opis zdarzenia powodującego uszkodzenie`,
    DESELECT_ALL: `Odznacz wszystko`,
    DETAILS: `Szczegóły`,
    DIAGNOSTICS_COVERED: `Diagnostyka w zakresie`,
    DIS_VSR: `Wyświetlane wiadomości`,
    DISPLAY: `Wyświetl`,
    DISPLAY_CLAIM: `Wyświetl reklamację`,
    DISPLAY_CREDIT_MEMO: `Wyświetl notę kredytową`,
    DISPLAY_FORMAT: `Format wyświetlania`,
    DISPLAY_PRODUCT: `Wyświetl Produkt`,
    DISPLAY_TAG: `Wyświetl znacznik`,
    DISTANCE: `Odległość`,
    DISTANCE_FROM_CURRENT_DEALER: `Odległość od bieżącego sprzedawcy`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Odległość od potencjalnego sprzedawcy`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Odległość od konta odpowiedzialnego`,
    DIVISION: `Dział`,
    DIVISION_SUMMARY: `Podsumowanie działu`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `Czy chcesz zapisać zmiany?`,
    DOES_NOT_CONTAIN: `Nie zawiera`,
    DOWNLOAD_TO_EXCEL: `Pobierz do programu Excel`,
    DOWNTIME: `Czas przestojów`,
    DOWNTIME_IS_REQUIRED: `Wymagany jest przestój`,
    DRAFT: `Zapisz w wersjach roboczych`,
    DTAC_CASE: `Sprawa DTAC`,
    DTAC_CASE_NUMBER: `Numer przypadku DTAC`,
    DTAC_SOLUTION: `Rozwiązanie DTAC`,
    DUE_DATE: `Termin realizacji`,
    DUE_WITHIN_3_MONTHS: `Realizacja w ciągu 3 miesięcy`,
    DUPLICATE_PIN_PLATE: `Zduplikowana tabliczka z numerem PIN`,
    DUPLICATE_PIN_PLATE_REPORT: `Raport o zduplikowanej tabliczce z numerem PIN`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Zaktualizowano żądanie zduplikowanej tabliczki z numerem PIN`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Pomyślnie utworzono żądanie zduplikowanej tabliczki z numerem PIN`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Zduplikowane żądanie tabliczki z numerem PIN ({count})`,
    EDIT: `Edytuj`,
    EDIT_CUSTOMER: `Edytuj klienta`,
    EDIT_LAYOUT: `Edytuj Układ`,
    EDIT_WITH_PARENTHESES: `(Edytuj)`,
    EFFECTIVE: `Efektywność`,
    EFFECTIVE_DATE: `Data wejścia w życie`,
    EMAIL: `E-mail`,
    EMISSIONS_PART_SEARCH: `Wyszukiwanie części układu wydechowego`,
    END_DATE: `Data końcowa`,
    END_USE: `Użytkowanie końcowe`,
    END_USE_CODE: `Kod użytkowania końcowego`,
    END_USE_CODE_REQUIRED: `Wymagany kod użytkowania końcowego`,
    ENDS_WITH: `Kończy się na`,
    ENGLISH: `Angielski`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `Wpisz liczbę z przedziału 0–1000`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `Wprowadź liczbę z zakresu od 0 do 10000`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `Wpisz liczbę 1–9999`,
    ENTER_A_PART_NUMBER: `Wprowadź numer części`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `Wpisz komentarz przed kontynuowaniem`,
    ENTITY_ID: `Identyfikator podmiotu`,
    EQUALS: `Równa się`,
    ERROR: `BŁĄD`,
    ERROR_MESSAGE_TITLE: `Wystąpił błąd`,
    ERROR_MESSAGES: `Komunikaty o błędach`,
    ERROR_MESSAGES_TITLE: `Wystąpiły błędy`,
    ERROR_NETWORK_ISSUES: `Błąd sieci uniemożliwił wczytanie niektórych danych — spróbuj ponownie`,
    ERROR_NO_DATA_TO_EXPORT: `Brak danych do wyeksportowania`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `Błąd podczas pobierania informacji o odbiorcy`,
    ERROR_SAP: `Brak możliwości połączenia z serwerem. Jeśli problem będzie się powtarzał, wybierz łącze „Skontaktuj się z nami”, aby uzyskać pomoc przy rozwiązywaniu problemu.`,
    ERROR_SESSION: `Sesja wygasła. Odśwież stronę, aby powtórnie się zalogować.`,
    ERROR_UNHANDLED: `Nieoczekiwany błąd systemu. Jeśli problem będzie się powtarzał, skorzystaj z funkcji „Pomoc” lub wybierz łącze „Skontaktuj się z nami”, aby uzyskać pomoc przy rozwiązywaniu problemu.`,
    ERROR_UPLOADING_FILE: `Plik nie został dodany`,
    ESTIMATED_BASIC_DATE: `Przewidywana data podstawowa`,
    ESTIMATED_BASIC_DAYS: `Przewidywana liczba dni bazowych`,
    ESTIMATED_HOURS: `Szacowane godziny`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `Szacunki mogą nie uwzględniać stanu demo lub godzin jeszcze niezgłoszonych`,
    EXCEEDS_DEMO_THRESHOLD: `Przekracza próg dla demonstracji`,
    EXCHANGE_RATE: `Kurs walut`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `Wyłączone numery PIN nie są uwzględnione w tym raporcie.`,
    EXECUTE: `Wykonaj`,
    EXPAND_ALL: `Rozwiń wszystko`,
    EXPECTED_FIRST_USE: `Przewidywane pierwsze użytkowanie`,
    EXPIRATION_DATE: `Data ważności`,
    EXPIRED: `Wygasł`,
    EXPIRED_PART_REQUESTS: `Wygasłe żądania części`,
    EXPIRED_PIPS: `Przedawnione PIP`,
    EXPIRES: `Upływa`,
    EXPIRING_SOON: `Niedługo wygaśnie`,
    EXPORT: `Eksportuj`,
    EXTENDED_WARRANTY: `Rozszerzona gwarancja`,
    FACTORY: `FABRYKA`,
    FACTORY_DUPLICATE_PIN_PLATE: `Zduplikowana tabliczka z numerem PIN`,
    FACTORY_NAME: `Nazwa fabryki`,
    FACTORY_USERS_TAB: `Zduplikowana tabliczka z numerem PIN ({count})`,
    FAILED: `Usterka`,
    FAILED_AREA: `Obszar wystąpienia usterki`,
    FAILED_AREA_IS_REQUIRED: `Wymagane jest wypełnienie pola usterki`,
    FAILED_DATE: `Data usterki`,
    FAILED_DATE_IS_REQUIRED: `Wymagane jest podanie daty usterki`,
    FAILED_MODE: `Tryb awaryjny`,
    FAILED_MODE_COMMENTS: `Uwagi do trybu awaryjnego`,
    FAILED_PART: `Uszkodzona część`,
    FAILED_PART_DESCRIPTION: `Opis uszkodzonej części`,
    FAILED_PART_IS_A_REMAN_PART: `Niepowodzenie Część jest częścią ReMan`,
    FAILED_PART_IS_REQUIRED: `Wymagane jest wypełnienie pola „Uszkodzona część”`,
    FAILED_PART_SERIAL: `Numer seryjny uszkodzonej części`,
    FAILED_PART_SERIAL_IS_REQUIRED: `Wymagany jest numer seryjny uszkodzonej części`,
    FAILURE_DATE: `Data awarii`,
    FAILURE_INFORMATION: `Informacje o awarii`,
    FAILURE_MODE: `Tryb awarii`,
    FAILURE_MODE_IS_REQUIRED: `Wymagane jest podanie trybu usterki`,
    FAILURE_PART: `Uszkodzona część`,
    FAILURE_PART_DESCRIPTION: `Opis uszkodzonej części`,
    FAILURE_PART_IS_REQUIRED: `Wymagana jest uszkodzona część.`,
    FAILURE_TO_RETURN_PARTS_WARNING: `Brak zwrotu żądanych części może spowodować obciążenie rachunku.`,
    FAVORITES: `Ulubiony`,
    FILE_NAME: `Nazwa pliku`,
    FILE_SIZE_IS_TOO_BIG: `Rozmiar pliku jest zbyt duży (maksymalny rozmiar 10 MB)`,
    FILE_SIZE_IS_TOO_BIG_CSV: `Rozmiar pliku jest zbyt duży (maksymalny rozmiar 1 MB)`,
    FILE_UPLOAD_MESSAGE: `Upuść pliki tutaj lub kliknij, aby je dodać (maksymalny rozmiar 10 MB)`,
    FILE_UPLOAD_MESSAGE_CSV: `Upuść pliki tutaj lub kliknij, aby je dodać (maksymalny rozmiar 1 MB)`,
    FILE_UPLOAD_MESSAGE_IMAGE: `Upuść obrazy tutaj lub kliknij, aby je dodać (maksymalny rozmiar 10 MB).`,
    FILE_UPLOAD_MESSAGE_SINGLE: `Upuść tutaj pojedynczy plik lub kliknij, aby dodać (maksymalny rozmiar 10 MB)`,
    FILE_UPLOAD_UNABLE_TO_READ: `System nie mógł odczytać pliku.  Porównaj go z szablonem i spróbuj ponownie.`,
    FILES: `Pliki`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Brak wyników. Nacisnąć Enter, aby wyszukać wszystkie zalecenia.`,
    FILTER_PLACEHOLDER: `Filtruj wyniki`,
    FILTER_WITH_ELLIPSIS: `Filtr...`,
    FILTERED_BY_COLUMN_ID: `Filtruj wg. {columnId}`,
    FIND_CUSTOMER: `Znajdź klienta`,
    FINNISH: `Fiński`,
    FIRST_MAINTENANCE: `PIERWSZA KONSERWACJA`,
    FIRST_NAME: `Imię`,
    FIRST_NAME_IS_REQUIRED: `Wymagane jest podanie imienia`,
    FIRST_SHIP_TO_LOCATION: `Miejsce pierwszej dostawy`,
    FIRST_USE: `Pierwsze użytkowanie`,
    FISCAL_YEAR: `Rok fiskalny`,
    FLUID_SAMPLING_REQUIRED: `Wymagane próbkowanie płynu`,
    FORWARDED: `PRZEKAZANO`,
    FRENCH: `Francuski`,
    FRWRD: `Do przodu`,
    FULL_DEBIT: `Pełny debet`,
    GENERAL: `Informacje ogólne`,
    GERMAN: `Niemiecki`,
    GET_MAINTENANCE_PLANS: `Uzyskaj plany konserwacji`,
    GOODS_INSTALLATION_VAT: `Instalacja towarów — VAT`,
    GRACE_PERIOD: `Okres Prolongaty`,
    GREATER_THAN: `Więcej niż`,
    GREATER_THAN_OR_EQUALS: `Więcej lub równo jak`,
    GROUP_COMPLETE: `Grupa kompletna`,
    GST_PERCENTAGE: `GST Odsetek`,
    H_LIMIT: `Limit godzin`,
    HISTORY_TO_DISPLAY: `Historia do wyświetlenia (dni)`,
    HOME: `Strona główna`,
    HOUR_LIMIT: `Limit godzin`,
    HOURS: `Godziny`,
    HOURS_ON_RENT: `Czas wypożyczenia (godziny)`,
    HSN_SAC_CODE: `HSN/SAC Code`,
    IGST: `IGST`,
    IMPLEMENTS: `Narzędzia`,
    IN_RANGE: `W zakresie`,
    INCENTIVE: `Zachęta`,
    INCENTIVE_PROGRAMS: `Programy motywacyjne`,
    INCLUDE_FULLY_COMPLETE: `Dołącz w pełni kompletne PIP`,
    INDICATES_REQUIRED_FIELD: `Oznacza wymagane pola`,
    INFO_MESSAGE_TITLE: `Wysłano powiadomienie systemowe`,
    INFO_MESSAGES: `Komunikaty informacyjne`,
    INFO_MESSAGES_TITLE: `Wysłano powiadomienia systemowe`,
    INFO_REQUEST_STATUS_ERROR: `Informacje są gotowe do wysłania wraz z tym żądaniem.`,
    INFORMATION: `Informacja`,
    INFORMATION_REQUEST: `Żądanie informacji`,
    INFORMATION_REQUEST_STATUS: `Status żądania informacji`,
    INPUT_PIN: `Wprowadź PIN`,
    INSPECTION: `Kontrola`,
    INSTALLED_BY: `Zainstalowane przez`,
    INSTALLED_BY_IS_REQUIRED: `Wymagane jest wypełnienie pola „Zainstalowane przez”`,
    INTERNAL_DEERE_COMMENTS: `Wewnętrzne komentarze Deere`,
    INTERNAL_EQUIPMENT_NOTES: `Wewnętrzne uwagi dotyczące sprzętu`,
    INTERVAL_BEGINS: `Początek okresu`,
    INTERVAL_ENDS: `Koniec okresu`,
    INTERVAL_TYPE_DESCRIPTION: `Opis rodzaju okresu`,
    INVOICE_ACCOUNT: `Konto faktury`,
    INVOICE_DEALER: `Dealer fakturowany`,
    INVOICE_NUMBER: `Numer faktury`,
    INVOICE_REQUEST: `Wniosek o fakturę`,
    INVOICE_SENT: `Fakturę wysłano`,
    INVOICE_UPDATED_SUCCESSFULLY: `Aktualizacja faktury z powodzeniem`,
    INVOICED: `Wystawiono fakturę`,
    INVOICED_TO: `Wystawiono fakturę na`,
    IRC_PIN_MESSAGE: `Klient jest IRC i jest uprawniony do bezpłatnego czasu podróży i przejazdu przez pierwsze 500 godzin lub 12 miesięcy posiadania maszyny.`,
    ISSUED: `Wydano`,
    ITALIAN: `Włoski`,
    ITEM: `Elementu`,
    ITEM_NUMBER: `Numer elementu`,
    ITEM_NUMBER_IS_REQUIRED: `Wymagany jest numer elementu`,
    JDLINK_EXPIRES: `Usługa JDLink wygasa`,
    JDP_COMMENTS: `Komentarze JDP`,
    JDP_COMMENTS_IS_REQUIRED: `Wymagane są komentarze JDP`,
    JDP_CUSTOMER_RESOLUTION: `Rozwiązanie dla klienta JDP`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `Wymagane jest podanie rozwiązania dla klienta JDP`,
    JDP_REASON: `Przyczyna JDP`,
    JDP_REASON_IS_REQUIRED: `Wymagane jest podanie przyczyny JDP`,
    LABOR: `Praca`,
    LABOR_ADDITIVE: `Koszt pracy`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `Szczegóły dodatkowej robocizny`,
    LABOR_ADDITIVE_PIPS: `Dodatki pracownicze PIP`,
    LABOR_ADDITIVE_TAB: `Dodatkowa robocizna ({count})`,
    LABOR_ADJUSTMENT: `Regulacja pracy`,
    LABOR_COMMENTS: `Praca Uwagi`,
    LABOR_HOURS: `Pr. Godziny`,
    LABOR_ITEM_DETAILS: `Robocizna — {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `Stawka robocza została pomyślnie zatwierdzona`,
    LABOR_RATE_CHANGE_SUBMITTED: `Wysłana zmiana stawki roboczej`,
    LABOR_RATE_CHANGES_WITH_COUNT: `Liczba zmian stawki ({count})`,
    LABOR_RATE_CONFIRM: `Żądana stawka robocza jest niższa od obecnej. Czy na pewno chcesz przesłać to żądanie?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Tempa w czerwonym tekście oznaczają wzrost o ponad 10% w stosunku do istniejącego tempa`,
    LABOR_RATE_HISTORY: `Historia stawki roboczej`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `Stawka robocza została pomyślnie odrzucona`,
    LABOR_RATE_REQUESTS_STATUS: `Stan żądań stawki pracy`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Stawka robocza zwrócona pomyślnie`,
    LABOR_RATES: `Stawki za pracę`,
    LABOR_STATS: `Statystyka pracy`,
    LABOR_TOTAL: `Praca, łącznie`,
    LABOR_TYPE: `Rodzaj pracy`,
    LABOR_VALUE: `Wartość pracy`,
    LABOR_WITH_COUNT: `Robocizna ({count})`,
    LANGUAGE: `Język`,
    LAST_LOCATION_FROM: `Ostatnia lokalizacja`,
    LAST_NAME: `Nazwisko`,
    LAST_NAME_IS_REQUIRED: `Wymagane jest podanie nazwiska`,
    LAST_PERSONAL_CONTACT: `Ostatni kontakt osobisty`,
    LAST_SEEN: `Ostatnio widziane`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Ostatnio Widoczne Na Odpowiedzialnym Koncie`,
    LATEST: `Najnowsze`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `Szczegóły dotyczące organu ścigania`,
    LAYOUT_CREATED_SUCCESSFULLY: `Układ utworzony pomyślnie`,
    LAYOUT_DELETED_SUCCESSFULLY: `Układ został usunięty pomyślnie`,
    LAYOUT_NAME: `Nazwa układu`,
    LAYOUT_UPDATED_SUCCESSFULLY: `Układ został aktualizacja pomyślnie`,
    LEAD_ACCOUNT: `Konto główne`,
    LEAD_DEALER: `Główny dealer`,
    LESS_THAN: `Mniej niż`,
    LESS_THAN_OR_EQUALS: `Mniej lub równo jak`,
    LICENSE_PLATE_NUMBER: `Numer rejestracyjny`,
    LIFETIME: `Żywotność`,
    LINE_ITEMS_EXPORT: `Eksport elementów zamówienia`,
    LIST: `Lista`,
    LIST_TOTAL: `Suma lista`,
    LOCATION: `Lokalizacja`,
    LOCATION_DUE: `Lokalizacja docelowa`,
    LOCATIONS: `Lokalizacje`,
    LOCATIONS_WITH_COUNT: `Liczba lokalizacji ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `Maszyna jest już zarejestrowana dla tego klienta`,
    MACHINE_INFORMATION: `Informacje o urządzeniu`,
    MACHINE_MODEL_TYPE: `Model/typ maszyny`,
    MACHINE_MODEL_TYPE_REQUIRED: `Wymagany model/typ maszyny`,
    MACHINE_STATUS: `Status maszyny`,
    MACHINE_STATUS_UPDATE: `Aktualizacja stanu maszyny`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `Aktualizacja stanu maszyny zatwierdzona`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `Dokument aktualizacji stanu maszyny`,
    MACHINE_STATUS_UPDATE_REJECTED: `Aktualizacja stanu maszyny odrzucona`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `Aktualizacje stanu maszyny ({count})`,
    MACHINE_TYPE: `Rodzaj maszyny`,
    MACHINE_TYPE_IS_REQUIRED: `Wymagane jest podanie rodzaju maszyny`,
    MACHINE_USE: `Użytkowanie maszyny`,
    MAILING_RECIPIENT: `Adresat korespondencji (imię i nazwisko)`,
    MAILING_RECIPIENT_REQUIRED: `Wymagany adresat korespondencji`,
    MAINTENANCE: `Konserwacja`,
    MAINTENANCE_PLAN: `Plany konserwacji`,
    MAINTENANCE_PLAN_INFO: `Informacje o planie konserwacji`,
    MARK_AS_INPROCESS: `Oznacz jako w toku`,
    MARK_AS_REVIEW: `Oznacz jako poprawione`,
    MARKETING_INCENTIVE: `Marketing — Zachęta`,
    MARKETING_JD_PROMISE: `Marketing — obietnica JD`,
    MARKETING_MAINTENANCE_PLAN: `Marketing — plan przeglądów`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `Marketing — kanał masowy — działania kontynuacyjne`,
    MARKETING_MASS_CHANNEL_PDI: `Marketing — kanał masowy — PDI`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `Przekazanie klienta masowego`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `Pamiętaj, żeby skontaktować się z radcą prawnym w kwestii właściwych procedur dotyczących numerów zastrzeżonych obowiązujących w Twoim województwie, a także na poziomie państwowym, zanim wprowadzisz zmiany w programie dotyczącym kontaktu posprzedażowego`,
    MASS_CHANNEL_PDI_CLAIM: `Kanał masowy — PDI`,
    MASTER_WARRANTY_TYPE: `Typ gwarancji głównej`,
    MATERIAL: `Numer materiału`,
    MERCHANDISE: `Artykuły różne`,
    MESSAGE: `Wiadomość`,
    MESSAGES: `Wiadomości`,
    METHOD_OF_CONTACT: `Metoda kontaktu`,
    METHOD_OF_CONTACT_IS_REQUIRED: `Wymagane jest podanie metody kontaktu`,
    METRIC: `Metryka`,
    METRICS: `Jednostki metryczne`,
    MILEAGE_LIMIT: `Limit przebiegu`,
    MOBILE_PHONE: `Telefon komórkowy`,
    MODEL: `Model`,
    MODEL_NUMBER: `Numer modelu`,
    MODEL_YEAR: `Rok modelowy`,
    MODIFIED: `Zmodyfikowano`,
    MONTH_TO_DATE: `W bieżącym miesiącu`,
    MORE: `Jeszcze`,
    MULTIPLE: `Wiele`,
    NAME: `Imię i nazwisko`,
    NET: `Netto`,
    NET_AMOUNT: `Kwota netto`,
    NET_AMOUNT_PAID: `Uiszczona kwota netto`,
    NET_TOTAL: `Suma netto`,
    NEW: `NOWY`,
    NEW_ACCOUNT: `Nowe konto`,
    NEW_CLAIM: `Nowe roszczenie`,
    NEW_CLAIM_VALUE: `Nowa wartość reklamacji`,
    NEW_CUSTOMER_REQUIRED: `Wymagany nowy klient`,
    NEW_DEALER: `Nowy dealer`,
    NEW_DEALER_DISTANCE: `Odległość nowego sprzedawcy`,
    NEW_DEALER_LOCATION: `Lokalizacja nowego dealera`,
    NEW_LABOR_RATE: `Nowa stawka robocza`,
    NEW_REQUEST_ENTER_RATES: `Nowe żądanie - wprowadź stawki`,
    NEW_STATUS: `Nowy status`,
    NEW_TRANSFER: `Nowy transfer`,
    NEW_TRANSFER_CREATED: `Utworzono nowy transfer`,
    NEW_VALUE: `Nowa wartość`,
    NO: `NIE`,
    NO_ACTIVE_WARRANTY: `Brak ważnej gwarancji`,
    NO_AFFECTED_PINS: `Nie ma żadnych numerów PIN, za które odpowiedzialna byłaby Twoja działalność handlowa`,
    NO_AUTHORITY_TO_ACCESS: `Nie masz uprawnień dostępu do sieci JDWS. Aby zweryfikować uprawnienia, należy skontaktować się z pomocą techniczną i skontaktować się z pomocą techniczną, korzystając z kopii tego błędu tutaj`,
    NO_CLAIMS: `Brak roszczeń.`,
    NO_CUSTOMER_ASSOCIATED: `Brak powiązanego klienta`,
    NO_CUSTOMER_SELECTED: `Żaden klient nie został wybrany`,
    NO_DEALER_INVOICES: `Brak faktur dealera`,
    NO_DEALERS_MAPPED: `Brak dealerów powiązanych z Twoim identyfikatorem użytkownika. Skontaktuj się z administratorem systemu.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`Nie (jeżeli nie, zdjęcie musi być przedstawione jako dowód)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `No information available for this product`,
    NO_LABOR_COVERAGE: `Brak Pokrycia Robocizny`,
    NO_LOWERCASE: `Nie`,
    NO_MATCHING_DEALERS: `Brak dealerów spełniających warunki filtrowania.`,
    NO_OPEN_PART_REQUESTS: `Brak otwartych próśb o części`,
    NO_OPEN_PIPS: `Brak oczekujących roszczeń PIP`,
    NO_PARTS_RETURNED: `Nie zwrócono żadnych części`,
    NO_PIP_PRODUCTS: `Brak produktów PIP.`,
    NO_PRODUCT_FOUND: `Brak znalezionych produktów`,
    NO_REQUIRED_ITEMS: `Brak wymaganych elementów.`,
    NO_RESULTS: `Brak wyników`,
    NO_RESULTS_FOUND: `Brak wyników`,
    NO_ROWS_TO_SHOW: `Brak pól do wyświetlenia`,
    NO_SPECIAL_INSTRUCTIONS: `Brak specjalnych instrukcji.`,
    NO_TRAVEL: `Brak podróży`,
    NON_RECOVERABLE_TAXES: `Brak podatku do zwrotu`,
    NON_TRACKED_PINS_HELP_TEXT: `Niektóre produkty będą wyświetlane w gwarancji dopiero po rejestracji. Twoje kryteria wyszukiwania obejmują te produkty.`,
    NON_TRAVEL: `Brak podróży`,
    NONE: `Brak`,
    NORMAL: `NORMALNY`,
    NOT_EQUAL: `Nierówny`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Powiadomienie dodane pomyślnie`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Powiadomienie usunięte pomyślnie`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `Sekwencja powiadomień została pomyślnie zaktualizowana`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Powiadomienie zaktualizowane pomyślnie`,
    NOTIFICATIONS: `Powiadomienia`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `Liczba diagnostyk`,
    NUMBER_OF_OPEN_PIPS: `Liczba otwartych programów poprawy produktu (PIP) {number}`,
    NUMBER_OF_REPAIR_OCCURRENCES: `Liczba napraw`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `Liczba wymian`,
    OLD_LABOR_RATE: `Dotychczasowa stawka robocza`,
    ON_SHELF: `W magazynie`,
    ON_SHELF_COST: `Cena końcowa`,
    ONE_ITEM_MUST_BE_SELECTED: `Należy wybrać jeden element`,
    OPEN: `Oczekujący`,
    OPEN_PART_REQUESTS: `Otwórz wnioski o części`,
    OPEN_PART_REQUESTS_WITH_COUNT: `Otwarte wnioski o części ({count})`,
    OPEN_PIP_COUNT: `Otwórz licznik PIP`,
    OPEN_PIP_PROGRAMS: `Rejestr PIP`,
    OPEN_PIPS: `Otwarte PIP`,
    OPEN_PIPS_REPORT: `Otwórz raport PIP`,
    OPEN_PIPS_TAB: `Oczekujące roszczenia PIP ({count})`,
    OPEN_PIPS_Y_N: `Otwórz PIP (T/N)`,
    OPERATORS_COMPLAINT: `Czego dotyczyła reklamacja operatora?`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `Wymagana jest reklamacja operatora`,
    OPERATORS_MANUAL_NUMBER: `Numer Instrukcji obsługi`,
    OPTION_CODE: `Kod opcji`,
    OPTION_CODE_CREATED_SUCCESSFULLY: `Kod opcji stworzony pomyślnie`,
    OPTION_CODE_DELETED_SUCCESSFULLY: `Kod opcji usunięty pomyślnie`,
    OPTION_CODES: `Kody opcji`,
    OR: `lub`,
    ORIGINAL_CLAIM_VALUE: `Pierwotna wartość reklamacji`,
    ORIGINAL_SUBMISSION_DATE: `Oryginalna data wysłania`,
    ORIGINALLY_SUBMITTED: `Początkowo przesłano`,
    OTHER: `Inne`,
    OTHER_AMOUNT_OF_USE: `Inny Czas Użytkowania`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `Wymagany inny czas użytkowania`,
    OTHER_CREDIT: `Inny koszt`,
    OTHER_CREDIT_1: `Inny koszt 1`,
    OTHER_CREDIT_2: `Inny koszt 2`,
    OTHER_CREDIT_3: `Inny koszt 3`,
    OTHER_CREDIT_ADJUSTMENT: `Korekta innych kosztów`,
    OTHER_CREDIT_ITEM_DETAILS: `Inny koszt - {description} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL: `Całkowita liczba innych kredytów`,
    OTHER_CREDITS: `Inne koszty`,
    OTHER_CREDITS_WITH_COUNT: `Inne punkty ({count})`,
    OTHER_INSTRUCTIONS: `Inne instrukcje`,
    OUTPUT_PIN: `Wyjściowy kod PIN`,
    OVERDUE: `Termin upłynął`,
    OVERRIDE_ACCOUNT: `Nadpisz konto`,
    OVERRIDE_EFFECTIVE_DATE: `Data zastąpienia`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Nadpisz sugerowane konto`,
    OWNERSHIP_STATUS: `Status własnościowy`,
    OWNERSHIP_STATUS_IS_REQUIRED: `Wymagane jest podanie statusu własnościowego`,
    PART: `Część`,
    PART_1: `Część 1`,
    PART_2: `Część 2`,
    PART_3: `Część 3`,
    PART_4: `Część 4`,
    PART_5: `Część 5`,
    PART_6: `Część 6`,
    PART_7: `Część 7`,
    PART_8: `Część 8`,
    PART_9: `Część 9`,
    PART_10: `Część 10`,
    PART_AMONT_OF_USE: `Czas użytkowania części`,
    PART_FAMILY: `Rodzina części`,
    PART_ITEM_DETAILS: `Części — {quantity} {description}; numer części {partNumber}`,
    PART_NUMBER: `Numer części`,
    PART_REQUEST: `Wniosek o część`,
    PART_REQUEST_NUMBER: `Wniosek o części {rgaNumber}`,
    PART_REQUEST_STATUS: `Status wniosku o części`,
    PART_REQUESTS: `Wnioski o części`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `Wprowadź numer roszczenia, przynajmniej 4 znaki`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `Wyszukiwana nazwa roszczenia musi składać się przynajmniej z 4 znaków`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `Wyszukiwany numer przypadku DTAC musi być pełny i składać się przynajmniej z 4 znaków`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `Wprowadź pełny numer przypadku DTAC`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `Wyszukiwany numer części musi składać się przynajmniej z 4 znaków`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `Wprowadź numer części, przynajmniej 4 znaki`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `Wyszukiwany numer wniosku o część musi składać się przynajmniej z 4 znaków`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `Wprowadź numer wniosku o część, przynajmniej 4 znaki`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `Wyszukiwany PIN musi składać się przynajmniej z 4 znaków`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `Wprowadź PIN, przynajmniej 4 znaki`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `Wyszukiwana nazwa harmonogramu pracy musi być pełna i składać się przynajmniej z 2 znaków`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `Wprowadź pełny harmonogram pracy`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `Pomyślnie zaktualizowano wniosek o część`,
    PART_RETURN: `Wniosek o zwrot części`,
    PART_RETURNS: `Zwroty części`,
    PART_SERIAL_NUMBER: `Numer seryjny części`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `Wymagany jest numer seryjny części`,
    PART_TOTAL: `Ogół części`,
    PART_TYPE: `Rodzaj części`,
    PART_USE: `Zużycie części`,
    PART_VALUE: `Wartość części`,
    PARTIAL_DEBIT: `Częściowy debet`,
    PARTICIPANT: `Uczestnik`,
    PARTS: `CZĘŚCI`,
    PARTS_ADDITIVE: `Dodatkowe koszty częsci`,
    PARTS_ADJUSTMENT:`Regulacja części`,
    PARTS_COVERAGE_SEARCH: `Wyszukiwanie pokrycia części`,
    PARTS_TEMPLATE: `Szablon części`,
    PARTS_USE: `Użycie części`,
    PARTS_USE_IS_REQUIRED: `Wymagane jest wypełnienie pola „Zużycie części”`,
    PARTS_WITH_COUNT: `Części ({count})`,
    PARTS_WITH_PARENTHESES: `Części`,
    PAST_DUE: `Po terminie`,
    PAYER_ACCOUNT: `Konto płatnika`,
    PC_LIMIT:`Limit bel`,
    PERCENT_COMPLETE: `Procent ukończony`,
    PERCENTAGE: `Odsetek`,
    PERCENTAGE_DEBIT: `Obciążenie procentowe`,
    PERCENTAGE_SYMBOL: `{percentage}%`,
    PERCENTAGE_TO_DEBIT: `Procent do obciążenia`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`W przypadku maszyn trwale nieczynnych należy dołączyć zdjęcie maszyny w celu sprawdzenia, czy nie można odbudować, naprawić ani użyć maszyny w żadnym momencie w przyszłości. Maszyny stacjonarne z wyłączonym systemem kwalifikują się do PIP dowolnego rodzaju.`,
    PERSON_RESPONSIBLE: `Osoba odpowiedzialna`,
    PHONE: `TELEFON`,
    PHONE_REQUIRED: `Wymagany jest telefon`,
    PICTURE: `Obraz`,
    PICTURE_REQUEST: `Prośba o zdjęcia`,
    PICTURE_REQUEST_STATUS: `Status prośba o zdjęcia`,
    PICTURE_REQUEST_STATUS_ERROR: `Attachments are ready to be sent along with this request.`,
    PIN: `PIN`,
    PIN_CREATED_SUCCESSFULLY: `Numer PIN został pomyślnie utworzony`,
    PIN_CROSS_REFERENCE: `Numer PIN referencji krzyżowej`,
    PIN_INVALID: `Nieprawidłowy kod PIN`,
    PIN_IS_REQUIRED: `Wymagany jest kod PIN`,
    PIN_REQUIRED: `Wymagany kod PIN`,
    PIN_SEARCH: `Wyszukiwanie PIN`,
    PIN_SEARCH_INFORMATION: `Informacje dotyczące wyszukiwania PIN`,
    PIN_TRANSFER_INFORMATION: `Informacje dotyczące transferu PIN`,
    PINS: `Numery PIN`,
    PINS_NOT_REGISTERED: `Kody PIN nie są zarejestrowane`,
    PIP: `PIP`,
    PIP_CODE: `Kod PIP`,
    PIP_CODE_CREATED_SUCCESSFULLY: `Pomyślnie utworzono wniosek o kod PIP`,
    PIP_CODE_REQUEST: `Wniosek o kod PIP`,
    PIP_CODE_REQUEST_APPROVED: `Wniosek o kod PIP zatwierdzony`,
    PIP_CODE_REQUEST_REJECTED: `Wniosek o kod PIP odrzucony`,
    PIP_CODE_REQUESTS_WITH_COUNT: `Wnioski o kod PIP ({count})`,
    PIP_COMPLETION_STATUS: `Status kompletności PIP`,
    PIP_DETAILS: `Szczegóły kodu PIP`,
    PIP_HISTORY: `Historia PIP`,
    PIP_ID: `Nr PIP`,
    PIP_NUMBER: `Numer PIP`,
    PIP_PROGRAM: `Program PIP`,
    PIP_PROGRAM_IS_REQUIRED: `Wymagane jest wypełnienie pola „Program PIP”`,
    PIP_PROGRAMS: `Programy PIP`,
    PIP_SEARCH: `Wyszukiwanie PIP`,
    PIP_STATUS: `Status PIP`,
    PIP_TYPE: `Rodzaj numeru PIP`,
    PIP_TYPES: `Rodzaj PIP`,
    PIPS: `PIP`,
    PIPS_UNPAID_LABOR_ADDITIVE: `Niepłatne dodatki pracownicze PIP`,
    PLAN_DESCRIPTION: `Opis planu`,
    PLAN_END_DATE: `Planowana data zakończenia`,
    PLAN_ENDS: `Data zakończenia planu`,
    PLAN_NAME: `Nazwa planu`,
    PLAN_NAME_IS_REQUIRED: `Wymagana jest nazwa planu`,
    PLAN_NAMES: `Nazwy planów`,
    PLAN_START_DATE: `Planowana data rozpoczęcia`,
    PLAN_STARTS: `Data rozpoczęcia planu`,
    PLANNED_BY: `Planowane przez`,
    PLANT: `Zakład`,
    PLATE_REQUEST_INFORMATION: `Informacje o żądaniu tabliczki`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `Wybierz główne konto`,
    PLEASE_SELECT_CLAIM_TYPE: `Wybierz typ roszczenia`,
    POLISH: `Polskie`,
    PORTUGUESE: `Portugalski`,
    POSTAGE_DELIVERY_DATE: `Data dostawy przesyłki`,
    POSTAL_CODE: `Kod pocztowy`,
    POSTAL_CODE_REQUIRED: `Wymagany kod pocztowy`,
    POSTAL_TRACKING_NUMBER: `Nr śledzenia przesyłki`,
    POTENTIAL_RESPONSIBLE_DEALER: `Potencjalny odpowiedzialny sprzedawca`,
    PRE_DELIVERY_INSPECTION: `Kontrola przed dostawą`,
    PREFERRED_THEME: `Preferowany motyw`,
    PREPARE_AUDIT: `Przygotuj audyt`,
    PREPARED: `Przygotowane`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `Przygotowywanie audytu dla dealera {dealer}`,
    PREVIOUS_AMOUNT_OF_USE: `Poprzedni Czas Użytkowania`,
    PREVIOUS_INVOICE_NUMBER: `Numer poprzedniej faktury`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `Wymagany jest numer poprzedniej faktury`,
    PREVIOUS_MONTH: `W poprzednim miesiącu`,
    PRICE: `Cena`,
    PRICING_SUMMARY: `Podsumowanie wyceny`,
    PRIMARY_ACTION: `Główne działanie`,
    PRIMARY_LANGUAGE: `Główny język`,
    PRINT: `Drukuj`,
    PRINT_CLAIM: `Drukuj roszczenie`,
    PRINT_REGISTRATION_FORM: `Drukuj formularz rejestracyjny ?`,
    PRINT_REGISTRATION_FORM_MESSAGE: `Produkt zarejestrowany na pierwszego właściciela. Czy wydrukować formularz rejestracyjny ?`,
    PRINT_TO_PDF: `Drukuj PDF`,
    PRIORITY: `Priorytet`,
    PRNT_CLM: `Wyświetl reklamację`,
    PROCESS_DATE: `Data przetworzenia`,
    PROCESSED: `Przetworzono`,
    PROCESSED_PART_REQUESTS: `Przetworzone żądania części`,
    PROCESSING_STATUS: `Status przetwarzania`,
    PROCESSING_STATUS_DESCRIPTION: `Przetwarzanie opisu statusu`,
    PRODUCT_DETAILS: `Szczegóły produktów`,
    PRODUCT_HIERARCHY: `Hierarchia produktu`,
    PRODUCT_INFORMATION: `Informacje o produkcie`,
    PRODUCT_REGISTERED: `Produkt zarejestrowany`,
    PRODUCT_REGISTRATION: `Rejestracja produktu`,
    PRODUCT_REGISTRATION_PENDED: `Rejestracja produktu wstrzymana`,
    PRODUCT_TRACKING: `Śledzenie produktu`,
    PRODUCTS: `Produkty`,
    PRODUCTS_BY_CUSTOMER: `Produkty według klienta`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `Historyczne kody PIN mogą nie być dostępne w wynikach wyszukiwania z powodu przejściowego problemu z łącznością systemu`,
    PRODUCTS_WITH_COUNT: `Produkty ({count})`,
    PROGRAM: `Programu`,
    PROGRAM_DESCRIPTION: `Opis programu`,
    PROGRAM_IS_REQUIRED: `Nazwa programu jest wymagana.`,
    PROGRAM_NAME: `Nazwa programu`,
    PROGRAM_NAME_IS_REQUIRED: `Nazwa programu jest wymagana.`,
    PROGRAM_NUMBER: `Numer programu`,
    PRT: `PRT`,
    PRTS: `PRT`,
    PURCHASE_INFO: `Informacje o zakupie`,
    PURCHASE_ORDER: `Zamówienie zakupu`,
    PURCHASE_ORDER_IS_REQUIRED: `Wymagane jest wypełnienie pola „Zamówienie zakupu”`,
    PURCHASER_TYPE: `Rodzaj kupującego`,
    PURCHASER_TYPE_REQUIRED: `Wymagany rodzaj kupującego`,
    PUSH_XML: `Wyślij ponownie XML`,
    QTY: `Il.`,
    QUALIFY_FOR_EMISSIONS: `Zakwalifikować do układu wydechowego`,
    QUANTITY: `Ilość`,
    QUANTITY_1: `Ilość 1`,
    QUANTITY_2: `Ilość 2`,
    QUANTITY_3: `Ilość 3`,
    QUANTITY_4: `Ilość 4`,
    QUANTITY_5: `Ilość 5`,
    QUANTITY_6: `Ilość 6`,
    QUANTITY_7: `Ilość 7`,
    QUANTITY_8: `Ilość 8`,
    QUANTITY_9: `Ilość 9`,
    QUANTITY_10: `Ilość 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `Zapytanie musi mieć co najmniej 3 znaki`,
    QUEST_DESC: `Opis nieprawidłowego`,
    QUESTIONABLE_PART: `Wątpliwa część`,
    QUEUED: `W kolejce`,
    READING_DATE: `Data odczytu`,
    REASON: `Przyczyna`,
    REASON_EVENT_NUMBER: `Numer zdarzenia przyczyny`,
    REASON_FOR_CHANGE: `Przyczyna zmiany`,
    REASON_FOR_DEBIT: `Przyczyna debetu`,
    REASON_FOR_MISSING_PLATE: `Przyczyna braku tabliczki`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Wymagana przyczyna braku tabliczki`,
    REASON_FOR_OVERRIDE: `Przyczyna zastąpienia`,
    REASON_FOR_REFUSAL: `Powód odmowy`,
    REASON_FOR_RETURN: `Powód zwrotu`,
    REASON_FOR_RETURN_IS_REQUIRED: `Wymagane jest podanie powodu zwrotu`,
    REASON_FOR_TRANSFER: `Powód transferu`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `Powód transferu musi się składać ze znaków alfanumerycznych`,
    REASON_FOR_TRANSFER_REJECTION: `Przyczyna odrzucenia transferu`,
    RECIPIENT_DEALER_OR_TCSM: `Odbiorca (dealer lub TCSM)`,
    RECIPIENT_MAILING: `Adresat korespondencji`,
    RECOMMENDATION: `Zalecenie`,
    RECOMMENDATION_DATE: `Data rekomendacji`,
    RECOMMENDED_ACCOUNT: `Zalecane konto`,
    RECONCILE: `Uzgodnienie`,
    RECONCILE_CLAIM: `Uzgodnij roszczenie`,
    RECONCILED: `UZGODNIONE`,
    RECORD_AUDIT: `Zapis audytu`,
    RECORD_AUDIT_FOR: `Zapis audytu dla użytkownika {dealer}`,
    RECORDS_FOUND: `Znalezione dokumenty {countToDisplay}`,
    RECOVERABLE_TAXES: `Podatek do zwrotu`,
    RECOVERED: `Odzyskano`,
    RECOVERED_WITH_MISSED_ADDITIVES: `Odzyskano z brakującymi dodatkami`,
    RECOVERED_WITHOUT_ADDITIVES: `Odzyskano bez dodatków`,
    RECOVERY: `Odzyskiwanie`,
    RED_MUST_BE_LESS_THAN_YELLOW: `Wartość czerwonego wskaźnika musi być niższa od wartości żółtego wskaźnika`,
    REFERENCE_1: `Referencja 1`,
    REFERENCE_2: `Odnośnik 2`,
    REFERENCE_INFORMATION: `Informacja referencyjna`,
    REFERENCE_NUMBER1: `Numer referencyjny 1`,
    REFERENCE_NUMBER2: `Numer referencyjny 2`,
    REGION: `Region`,
    REGISTER: `Zarejestruj`,
    REGISTER_A_PRODUCT_BY_PIN: `Zarejestruj produkt wg kodu PIN`,
    REGISTER_A_PRODUCT_TO_ADD: `Zarejestruj produkt i dodaj do systemu gwarancji`,
    REGISTER_ANOTHER_PRODUCT: `Zarejestruj się inny produkt`,
    REGISTER_PRODUCT: `Zarejestruj produkt`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `Zarejestruj produkt i dodaj inny`,
    REGISTERED: `Zarejestrowano`,
    REGISTRATION: `Rejestracja`,
    REGISTRATION_DATE: `Data rejestracji`,
    REGISTRATION_DATES: `Daty rejestracji`,
    REGISTRATION_FORM: `Formularz rejestracji`,
    REGISTRATION_HISTORY: `Historia rejestracji`,
    REGISTRATION_NOT_ALLOWED: `Brak możliwości rejestracji tego produktu`,
    REGISTRATION_REVIEW: `Przegląd rejestracji`,
    REGISTRATION_REVIEW_TAB: `Przegląd rejestracji ({count})`,
    REGISTRATION_STATUS: `Status rejestracji`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `Statusu rejestracji nie można ustawić jako „Nowy”`,
    REGISTRATION_STATUS_REQUIRED: `Wymagany status rejestracji`,
    REGISTRATION_SUCCESS: `Rejestracja powiodła się`,
    REGISTRATION_TYPE: `Rodzaj rejestracji`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `Rodzaju rejestracji nie można ustawić jako „Nowy”`,
    REGISTRATION_TYPE_REQUIRED: `Wymagany rodzaj rejestracji`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Rejestracja zaktualizowana pomyślnie`,
    REGISTRATIONS_REVIEW: `Przegląd rejestracji`,
    REIMBURSED: `Zwrócono koszty`,
    REIMBURSED_AMOUNT: `Zwrócona kwota`,
    REIMBURSED_PERCENTAGE: `Zwrócona kwota (w procentach)`,
    REIMBURSED_PERCENTAGE_INDICATOR: `Wskaźnik zwróconej kwoty (w procentach)`,
    REIMBURSEMENT_DETAILS: `Szczegóły dotyczące zwrotu kosztów`,
    REIMBURSEMENT_PERCENTAGE: `Zwrot kosztów (w procentach)`,
    REIMBURSEMENT_SUMMARY: `Zestawienie zwrotu kosztów`,
    REJECT: `Odrzuć`,
    REJECT_LABOR_RATE: `Odrzuć stawkę roboczą`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `Odrzuć roszczenie dotyczące przydziału specjalnego`,
    REJECTED: `ODRZUCONY`,
    REJECTED_APPEAL: `ODWOŁANIE ODRZUCONE`,
    RELATIONSHIP: `Związek`,
    RELATIONSHIP_IS_REQUIRED: `Wymagane jest podanie relacji`,
    REMOVE_FILTER: `Usuń filtr`,
    REMOVE_FROM_AUDIT: `Usuń z audytu`,
    REMOVE_LAYOUT: `Usuń układ`,
    RENTAL_PINS: `PIN-y wynajmu`,
    REPAIR_DATE: `Data naprawy`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `Data naprawy nie może być wcześniejsza niż data wystąpienia usterki`,
    REPAIR_NUMBER: `Numer naprawy`,
    REPAIR_NUMBER_IS_REQUIRED: `Wymagany jest numer naprawy`,
    REPAIR_REPLACE_INDICATOR: `Wskaźnik napraw/wymian`,
    REPAIRED: `Naprawione`,
    REPAIRED_DATE: `Data naprawy`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `Data naprawy nie może być wcześniejsza niż data usterki`,
    REPAIRED_DATE_IS_REQUIRED: `Wymagana jest data naprawy`,
    REPORT_DATE: `Data raportu`,
    REPORT_NUMBER: `Numer raportu`,
    REPORTS: `Raporty`,
    REQ_ADDL: `Dopasuj kredyt`,
    REQUEST: `Żądanie`,
    REQUEST_DATE: `Data żądania`,
    REQUEST_DETAILS: `Szczegóły wniosku`,
    REQUEST_DUPLICATE_PIN_PLATE: `Zażądaj zduplikowanej tabliczki z numerem PIN`,
    REQUEST_FORM: `Formularz wniosku`,
    REQUEST_PIP_CODE: `Prześlij wniosek o kod PIP`,
    REQUEST_STATUS: `Status wniosku`,
    REQUEST_SUBMITTED: `Wniosek wysłany`,
    REQUEST_TYPE: `Typ żądania`,
    REQUEST_UPDATED_SUCCESSFULLY: `Żądanie zaktualizowane pomyślnie`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `Roszczenie o sprawdzenie obciążenia gwarancyjnego`,
    REQUESTED: `Żądanie`,
    REQUESTED_BY: `Wymagane przez`,
    REQUESTED_DATE: `Wybrana data`,
    REQUESTED_DATES: `Wymagane daty`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `Pożądany kwota diagnostyczna`,
    REQUESTED_DIAGNOSTIC_HOURS: `Pożądany godziny diagnostyczne`,
    REQUESTED_LABOR_AMOUNT: `Oczekiwane koszty pracy`,
    REQUESTED_LABOR_HOURS: `Wymagane godziny pracy`,
    REQUESTED_OTHER_CREDITS: `Inne kredyty, o które złożono wnioski`,
    REQUESTED_PARTS: `Części, o które złożono wnioski`,
    REQUESTED_REPAIR_AMOUNT: `Pożądany kwota naprawy`,
    REQUESTED_REPAIR_HOURS: `Pożądany godziny naprawy`,
    REQUESTED_TRAVEL_TOTAL: `Całkowita liczba wnioskowanych podróży`,
    REQUESTER_TCSM: `Zgłaszający (TCSM)`,
    REQUESTER_TCSM_REQUIRED: `Wymagany zleceniodawca (TCSM)`,
    REQUIRED: `wymagane`,
    REQUIRED_CRITERIA: `Wymagane kryteria`,
    REQUIRED_ITEMS: `Wymagane elementy`,
    RESEND_XML: `Wyślij ponownie XML`,
    RESET: `Zeruj`,
    RESPONDENT_INFORMATION: `Informacje dotyczące respondenta`,
    RESPONSIBILITY_OF: `Osoba odpowiedzialna`,
    RESPONSIBLE_ACCOUNT: `Konto winnego`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `Wymagane jest konto winnego`,
    RESPONSIBLE_DEALER: `Odpowiedzialny dealer`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Pokazano pierwsze 100 wyników. Pobrać, aby uzyskać pełne wyniki`,
    RET: `Zwrot`,
    RETAIL_INSTALL: `Sprzedaż/instalacja`,
    RETAIL_INSTALL_DATE: `Data sprzedaży/instalacji`,
    RETAIL_INSTALL_IS_REQUIRED: `Wymagane jest wypełnienie pola „Sprzedaż/instalacja”`,
    RETAILER_NAME: `Nazwa sprzedawcy`,
    RETAILER_NAME_IS_REQUIRED: `Wymagana jest nazwa sprzedawcy`,
    RETRY: `spróbuj`,
    RETURN: `Powrót`,
    RETURN_LABOR_RATE: `Zwrot stawki`,
    RETURN_REQUEST: `Powrót żądanie`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `Zwróć roszczenie dotyczące przydziału specjalnego`,
    RETURN_STATUS: `Status zwrotu`,
    RETURNED: `ZWRÓCONY`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `Data zwrotu nie może być wcześniejsza niż data dostarczenia`,
    RETURNED_DATE_IS_REQUIRED: `Wymagane jest podanie daty zwrotu`,
    RETURNED_MACHINE_STATUS_UPDATE: `Aktualizacja stanu zwróconej maszyny`,
    REVIEW_DEALER_RECOMMENDATIONS: `Czy na pewno chcesz oznaczyć numery PIN do weryfikacji?`,
    REVISE: `Sprawdź`,
    REVISED: `ZMODYFIKOWANO`,
    ROLLING_12_CREDIT_AMOUNT: `Przewiń 12 kwot kredytów`,
    ROLLING_12_MONTHS: `W ostatnich 12 miesiącach`,
    RUN_REPORT: `Sporządź raport`,
    RUSSIAN: `Rosyjski`,
    SAP_DOWN_WARNING: `Uszkodzenie funkcji systemu gwarancyjnego. Pracujemy nad jak najszybszym poprawieniem tej sytuacji. Odśwież przeglądarkę, aby sprawdzić dostępność systemu.`,
    SAVE: `Zapisz`,
    SAVE_AS_DRAFT: `Zapisz w wersjach roboczych`,
    SAVE_AS_NEW_LAYOUT: `Zapisz jako nowy układ`,
    SAVE_AUDIT: `Zapisz audyt`,
    SAVE_CHANGES: `Zapisz zmiany`,
    SAVE_TO_VALIDATE: `Zapisz, aby zatwierdzić`,
    SAVE_VALD: `Zapisz i zweryfikuj`,
    SAVE_VALIDATE: `Zapisz i zweryfikuj`,
    SEARCH: `Szukaj`,
    SEARCH_BOX_PLACEHOLDER: `Wpisz kod PIN, nr seryjny lub roszczenia, sprawę DTAC lub nazwę klienta`,
    SEARCH_BY_CLAIM_TYPE: `Wprowadź pełne określenie rodzaju roszczenia`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `Roszczenie należy wyszukiwać, wprowadzając jego pełną nazwę składającą się z 4–9 znaków`,
    SEARCH_BY_FAILURE_PART_NUMBER: `Wprowadź pełny numer uszkodzonej części`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `Roszczenie należy wyszukiwać, wprowadzając pełny numer uszkodzonej części się z przynajmniej 4 znaki`,
    SEARCH_BY_WORK_ORDER: `Wprowadź nazwę harmonogramu pracy, przynajmniej 2 znaki`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `Wyszukiwana nazwa harmonogramu pracy musi składać się z przynajmniej 2 znaki`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `Wpisz pełny numer roszczenia`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `Wyszukiwanie roszczenia musi się odbywać wg pełnego numeru roszczenia i zawierać od 4 do 9 znaków`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `Wpisz pełny numer seryjny komponentu`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `Wyszukiwanie komponentu należy wykonać za pomocą pełnego numeru seryjnego, przynajmniej 1 znak`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `Wprowadź numer PIN`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `Wpisz pełny numer modelu`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `Wyszukiwanie modelu musi uwzględniać pełny numer modelu zawierający od 3 do 12 znaków`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `Wprowadź PIN, przynajmniej 6 znaków`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `Wyszukiwany PIN musi składać się z 6–17 znaków`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `Wpisz numer PIP zawierający minimum 4 znaki`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `Wyszukiwany numer PIP musi zawierać od 4 do 12 znaków`,
    SEARCH_RESULTS_TAB: `Wyniki wyszukiwania ({count})`,
    SECOND_SHIP_TO_LOCATION: `Miejsce drugiej dostawy`,
    SELECT: `Wybierz`,
    SELECT_A_RANGE: `Wybierz zakres`,
    SELECT_ALL: `Wybierz wszystko`,
    SELECT_AUTO_SUBMIT: `Wybierz „Automatyczne wysyłanie”`,
    SELECT_BRANCH: `Wybierz filię`,
    SELECT_CLAIM_TYPE: `Wybierz rodzaj roszczenia`,
    SELECT_COLUMNS: `Wybierz Kolumny`,
    SELECT_COUNTRY: `Wybierz kraj`,
    SELECT_CSV_SEPARATOR: `Wybierz separator CSV`,
    SELECT_DATE_FORMAT: `Wybierz format daty`,
    SELECT_DEALERS_AND_STATUS: `Wybierz status i dealerów`,
    SELECT_DECIMAL_FORMAT: `Wybierz format dziesiętny`,
    SELECT_DISPLAY_FORMAT: `Wybierz format wyświetlania`,
    SELECT_FACTORY: `Wybierz fabrykę`,
    SELECT_LANGUAGE: `Wybierz język`,
    SELECT_LAYOUT: `Wybierz Układ`,
    SELECT_PIP_CODE: `Wybierz kod PIP`,
    SELECT_PLAN_NAMES: `Wybierz nazwy planów`,
    SELECT_SERVICE_INTERVAL_TYPES: `Wybierz rodzaje okien serwisowych`,
    SELECT_SORT_BY: `Wybierz Sortuj Według`,
    SELECT_SORT_DIRECTION: `Wybierz Kierunek Sortowania`,
    SELECT_STATE: `Wybierz stan`,
    SELECT_STATUS: `Wybierz status`,
    SELECT_TERRITORY: `Wybierz obszar`,
    SELECT_THEME: `Wybierz motyw`,
    SELECT_TIME_ZONE: `Wybierz strefę czasową`,
    SELECT_VALUES_TO_APPROVE: `Wybierz wartości, aby zatwierdzić`,
    SELECTED_COLUMNS: `Wybrane Kolumny`,
    SELECTED_FOR_AUDIT: `Wybrany dla audytu`,
    SELECTED_FOR_AUDIT_VSR: `Patrz rozwiązanie DTAC 221475 w celu uzyskania wymaganej dokumentacji audytu i załączników potrzebnych do tej reklamacji`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `Wybór wielu kont i rodzajów gwarancji wpływa na wydajność`,
    SEND: `Wyślij`,
    SERIAL_NUMBER: `Numer seryjny`,
    SERIAL_NUMBER_INVOICE_NUMBER: `Numer seryjny / Numer faktury`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `Wniosek anulowano ze względu na zbyt długie oczekiwanie na odpowiedź serwera. Postaraj się sformułować bardziej konkretny wniosek lub spróbuj ponownie później.`,
    SERVICE_DATE_IS_REQUIRED: `Wymagane są dane dotyczące obsługi`,
    SERVICE_INTERVAL: `Okres międzyserwisowy`,
    SERVICE_INTERVAL_BEGIN_DATE: `Data rozpoczęcia okna serwisowego`,
    SERVICE_INTERVAL_END_DATE: `Data zakończenia okna serwisowego`,
    SERVICE_INTERVAL_IS_REQUIRED: `Wymagane jest podanie czasu pracy między przeglądami`,
    SERVICE_INTERVAL_NUMBER: `Numer przerwy serwisowej`,
    SERVICE_INTERVAL_STATUS: `Stan przerwy serwisowej`,
    SERVICE_INTERVAL_TYPE: `Rodzaj okresu międzyserwisowego`,
    SERVICE_INTERVAL_TYPES: `Rodzaje okien serwisowych`,
    SERVICE_PART: `Część serwisowa`,
    SERVICE_UNAVAILABLE: `Usługa niedostępna`,
    SERVICED: `Serwisowano`,
    SERVICED_DATE_IS_REQUIRED: `Wymagana jest data usługi.`,
    SERVICED_IS_REQUIRED: `Wymagane jest serwisowanie.`,
    SET_AS_DEFAULT: `Ustaw jako domyślne`,
    SETTINGS: `Moje ustawienia`,
    SETTLED: `Zakończony`,
    SETTLEMENT_NO_REGISTRATION: `Zakończono — brak rejestracji`,
    SETUP: `Konfiguracja`,
    SETUP_DATE_IS_REQUIRED: `Wymagane jest podanie daty konfiguracji`,
    SETUP_IS_REQUIRED: `Wymagane jest wypełnienie pola „Konfiguracja”`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `Wyślij do`,
    SHIPPED: `Dostarczono`,
    SHIPPING_ID: `Identyfikator wysyłki`,
    SHIPPING_ID_REQUIRED: `Wymagany identyfikator wysyłki`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Informacje o wysyłce/instrukcje specjalne`,
    SHIPPING_INSTRUCTIONS: `Instrukcje dostawy`,
    SHORT_TEXT: `Krótki tekst`,
    SHORT_TEXT_IS_REQUIRED: `Krótki tekst jest wymagany`,
    SHOW_ALL: `Pokaż wszystko ({count})`,
    SHOW_EXCLUDED: `Pokaż wykluczone`,
    SHOW_MORE: `Pokaż więcej`,
    SHOW_MORE_GROUPS: `Pokaż więcej grup ({countToDisplay})`,
    SHOW_RED_IF_LESS_THAN: `Wyświetl na czerwono, jeśli mniej niż`,
    SHOW_REIMBURSED_AMOUNT: `Wyświetl zwróconą kwotę`,
    SHOW_REIMBURSED_PERCENTAGE: `Wyświetl zwróconą kwotę (w procentach)`,
    SHOW_YELLOW_IF_LESS_THAN: `Wyświetl na żółto, jeśli mniej niż`,
    SIGN_IN_REQUIRED: `Wymagane logowanie`,
    SIGN_OUT: `Wyloguj się`,
    SKIP_AUDIT: `Pomiń audyt`,
    SKIP_AUDIT_SUCCESS: `Audyt został pominięty, a termin jest teraz w przyszłości.`,
    SOME_PARTS_RETURNED: `Zwrócono niektóre części`,
    SORT_BY: `Sortuj według`,
    SPANISH: `Hiszpański`,
    SPECIAL_ALLOWANCE: `SPECJALNE POZWOLENIE`,
    SPECIAL_ALLOWANCE_CALCULATION: `Specjalna kalkulacja przydziału`,
    SPECIAL_ALLOWANCE_CLAIM: `Roszczenie dotyczące specjalnego pozwolenia`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `Status roszczenia dotyczącego przydziału specjalnego`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `Status roszczenia dotyczącego przydziału specjalnego`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `Status roszczenia dotyczącego przydziału specjalnego zaktualizowany`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `Numer roszczenia dotyczącego przydziału specjalnego — {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `Roszczenia dotyczące przydziału specjalnego ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `Wkład przydziału specjalnego`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `Opis przydziału specjalnego`,
    SPECIAL_ALLOWANCE_TYPE: `Typ roszczenia specjalnego`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `Wymagane jest podanie rodzaju przydziału specjalnego`,
    SPECIAL_INSTRUCTIONS: `Instrukcje specjalne`,
    SPG: `SPG`,
    SPGS: `Cennik usług serwisowych (SPG)`,
    STANDARD_VIEW: `Ogólna perspektywa`,
    START_AMOUNT_OF_USE: `Początkowy stopień wykorzystania`,
    STARTS: `Początek`,
    STARTS_WITH: `Zaczyną się z`,
    STATE: `Województwo`,
    STATE_PROVINCE: `Województwo`,
    STATE_PROVINCE_REQUIRED: `Wymagane województwo`,
    STATUS: `Status`,
    STATUS_CHANGE_REQUEST: `Wniosek o zmianę statusu`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `Pomyślnie utworzono wniosek o zmianę statusu`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `Żądanie stanu maszyny zaktualizowane pomyślnie`,
    STATUS_FOR: `Status elementu {pin}`,
    STATUS_INDICATOR: `Wskaźnik statusu`,
    STATUS_REASON: `Status przyczyny`,
    STOLEN_DATE: `Data kradzieży`,
    STORE: `Sklep`,
    STORE_IS_REQUIRED: `Wymagane jest wypełnienie pola „Sklep”`,
    STORE_NUMBER_IS_REQUIRED: `Wymagany jest numer sklepu`,
    STREET_1: `Ulica 1`,
    STREET_2: `Ulica 2`,
    SUB: `Wyślij`,
    SUB_CLAIM_TYPE: `Rodzaj reklamacji drugorzędnej`,
    SUB_TYPE: `Podtyp`,
    SUBMISSION_DATE: `Data wysłania`,
    SUBMIT: `Wyślij`,
    SUBMIT_AUDIT: `Wyślij audyt`,
    SUBMIT_AUDIT_FOR: `Wyślij audyt dla użytkownika {dealer}`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Wyślij pełne obciążenie roszczenia {claimNumber}`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Wyślij częściowe obciążenie roszczenia {claimNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER:`Wyślij procent roszczenia obciążenia dla {claimNumber}`,
    SUBMIT_REQUEST: `Prześlij wniosek`,
    SUBMITTED: `WYSŁANO`,
    SUBMITTED_AVAILABLE_TO_EDIT: `WYSŁANO (Edytowalne)`,
    SUCCESS: `Sukces`,
    SUCCESS_MESSAGE_TITLE: `Pomyślnie zakończono operację`,
    SUCCESS_MESSAGES_TITLE: `Pomyślnie zakończono operacje`,
    SUPPLIER_WARRANTY: `Gwarancja dostawcy`,
    SURVEY_QUESTIONS: `Pytania ankietowe`,
    SUSPENDED: `Zawieszony`,
    SWEDISH: `Szwedzki`,
    SYSTEM_SELECTED_CLAIMS: `Roszczenia wybrane przez system`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `Roszczenia wybrane przez system ({count})`,
    TABM: `TABM`,
    TAX: `Podatek`,
    TCSM: `TCSM`,
    TCSM_COMMENTS: `Uwagi TCSM`,
    TCSM_ID: `ID TCSM`,
    TECH_ID: `ID techn.`,
    TERMINATED: `Zakończony`,
    TERMINATES: `Data zakończenia`,
    TERRITORY: `Obszar`,
    TEST: `Test`,
    TEST_RESULTS_CODE: `Kod wyników testów`,
    THEME: `Motyw`,
    TIME_LIMIT: `Limit czasu`,
    TIME_ZONE: `Strefa czasowa`,
    TITLE: `Tytuł`,
    TITLE_IS_REQUIRED: `Tytuł jest wymagany`,
    TO: `Do`,
    TODAY: `Dzisiaj`,
    TOO_MANY_RESULTS: `Twoje żądanie zwróciło zbyt wiele wyników. Zawęź wyszukiwane terminy i spróbuj ponownie.`,
    TOTAL: `Razem`,
    TOTAL_AMOUNT: `Całkowita ilość`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Razem w PLN`,
    TOTAL_APPROVED: `Łącznie zatwierdzonych`,
    TOTAL_APPROVED_CLAIM_VALUE: `Całkowita wartość zaakceptowanych roszczeń`,
    TOTAL_APPROVED_INCLUDING_TAXES: `Wszystkie zaakceptowane z podatkami`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `Łączna liczba wszystkich zatwierdzonych roszczeń bez dodatków`,
    TOTAL_CONTRIBUTION: `Całkowity wkład`,
    TOTAL_REIMBURSED: `Całkowita kwota zwrotu`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `Całkowita wysokość zwróconej kwoty ({currency})`,
    TOTAL_REQUESTED: `Łącznie zgłoszonych`,
    TOTAL_REQUESTED_CLAIM_VALUE: `Całkowita wartość wnioskowanych roszczeń`,
    TOTAL_UNPAID: `Nieopłacone, łącznie`,
    TRACKING_NUMBER: `Numer śledzenia`,
    TRANSFER: `Transfer`,
    TRANSFER_ALL: `Przenieś wszystko`,
    TRANSFER_APPROVALS: `Zatwierdzenia transferów`,
    TRANSFER_APPROVALS_TAB: `Zatwierdzenia transferów ({count})`,
    TRANSFER_CREATED: `Utworzono transfer`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Przenieś rekomendacje dealera`,
    TRANSFER_REJECTED: `Przeniesienie odrzucone`,
    TRANSFER_UPDATED_SUCCESSFULLY: `Pomyślnie zaktualizowano transfer`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Przenieś wszystkie zalecenia dealera`,
    TRANSFERS: `Transfery`,
    TRAVEL: `Podróż`,
    TURKISH: `Turecki`,
    TWO_PERCENT_WITHHOLD_VALUE: `2% wartości potrącać`,
    TYPE: `Rodzaj`,
    TYPES: `Rodzaje`,
    UNABLE_TO_CONTACT_THE_SERVER: `Brak połączenia z serwerem`,
    UNABLE_TO_COPY_ATTACHMENTS: `Nie mogliśmy skopiować załączników z oryginalnego roszczenia, prosimy o zapoznanie się z nimi przed przesłaniem nowego roszczenia.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `Nie można wczytać szczegółów klienta`,
    UNDO: `Cofnij`,
    UNDO_REGISTRATION: `Cofnij rejestrację`,
    UNDO_REGISTRATION_SUCCESSFULL: `Cofnięcie rejestracji zakończone powodzeniem`,
    UNIT: `Jednostka`,
    UNIT_1: `Jednostka 1`,
    UNIT_2: `Jednostka 2`,
    UNIT_3: `Jednostka 3`,
    UNIT_OF_MEASURE: `Jednostka miary`,
    UNPAID_LABOR: `Nieopłacone prace`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `Niepłatne dodatki pracownicze — z wyłączeniem programu poprawy produktu (PIP)`,
    UNPAID_LABOR_ADDITIVES_PIPS: `Niepłatne dodatki pracownicze — PIP`,
    UNPAID_OTHER_CREDITS: `Inne niezapłacone kwoty`,
    UNPAID_PARTS: `Nieopłacone części`,
    UNPAID_PARTS_ADDITIVE: `Niezapłacony dodatek do części`,
    UNPAID_TRAVEL: `Niezapłacone koszty podróży`,
    UNRECONCIL: `Nieuzgodnione`,
    UNRECONCILE_CLAIM : `Nieuzgodnione roszczenie`,
    UNSUB: `Edytuj`,
    UNSUBMIT_CLAIM: `Edytuj Reklamacja`,
    UPDATE: `Aktualizacja`,
    UPDATE_CUSTOMER_INFORMATION: `Aktualizuj informacje o kliencie`,
    UPDATE_LABOR_RATES: `Aktualizacja stawki roboczej`,
    UPDATE_LAYOUT: `Aktualizacja Układ`,
    UPDATE_MACHINE_STATUS: `Aktualizuj stan urządzenia`,
    UPDATE_MACHINE_STATUS_HISTORY: `Historia aktualizacji statusu urządzenia`,
    UPDATE_REGISTRATION: `Aktualizuj rejestrację`,
    UPDATE_SELECTED: `Aktualizuj wybrane`,
    UPDATED: `Zaktualizowano`,
    UPDATED_BY: `Aktualizowany przez`,
    UPDATED_DATE_FROM: `Zaktualizowano datę od`,
    UPDATED_DATE_TO: `Zaktualizowano datę do`,
    UPLOAD_DOCUMENT: `Przekaż dokument`,
    UPTIME_ASSURANCE: `Zapewnienie czasu pracy`,
    USEFUL_LINKS: `Przydatne linki`,
    USER: `użytkownika`,
    USER_PREFERENCES_UPDATED: `Zaktualizowano preferencje użytkownika`,
    USER_SELECTED: `Wybrane przez użytkownika`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `Roszczenia wybrane przez użytkownika ({count})`,
    USERS_INFORMATION: `Informacje o użytkownikach`,
    VALIDATE: `Zatwierdź`,
    VALIDATE_CLAIM: `Weryfikuj roszczenie`,
    VALUE: `Wartość`,
    VALUE_OF_REPAIR: `Wartość naprawy`,
    VIEW_CLAIM: `Zobacz roszczenie`,
    VIEW_DETAILS: `Wyświetl szczegóły`,
    VIEW_OPEN_PIPS: `Wyświetl otwarte programy PIP`,
    VIEW_PIP: `Wyświetl PIP`,
    VIEW_PRODUCTS: `Wyświetl produkty`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `Pokaż produkty & Uaktualnij informacje`,
    VIEW_UPDATE: `Zobacz/Aktualizuj`,
    VSR_MESSAGES: `Wiadomości VSR`,
    WAITING_FOR_DLR_INV: `Oczekiwanie na fakturę dla sprzedawcy`,
    WAITING_FOR_INVOICE: `Oczekiwanie na fakturę ({count})`,
    WAITING_SINCE: `Oczekiwanie trwa od`,
    WARNING_MESSAGE_TITLE: `Wysłano ostrzeżenie`,
    WARNING_MESSAGES: `Komunikaty ostrzegawcze`,
    WARNING_MESSAGES_TITLE: `Wysłano ostrzeżenia`,
    WARRANTY: `Gwarancja`,
    WARRANTY_ADMIN: `Administrator Gwarancja`,
    WARRANTY_CLAIM_TYPE: `Rodzaj reklamacji gwarancyjnej`,
    WARRANTY_COVERAGE: `Okres gwarancyjny`,
    WARRANTY_EXPIRATION: `Wygaśnięcie gwarancji`,
    WARRANTY_TYPE: `Rodzaj gwarancji`,
    WARRANTY_TYPES: `Rodzaje gwarancji`,
    WEAR_PARTS: `Noszenie części`,
    WEAR_PARTS_COVERAGE: `Zakres zużycia części`,
    WELCOME: `Witamy`,
    WINTERIZATION: `Zimowanie`,
    WIP: `Praca w toku`,
    WITH_ADDITIVES: `Z dodatkami`,
    WITNESS_FIRST_NAME: `Imię świadka`,
    WITNESS_LAST_NAME: `Nazwisko świadka`,
    WORK_ORDER: `Harmonogram pracy`,
    WORK_ORDER_NUMBER: `Numer harmonogramu pracy`,
    WORK_ORDER_ONE: `Harmonogram pracy 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `Wymagane jest podanie harmonogramu pracy nr 1`,
    WORK_ORDER_THREE: `Harmonogram pracy 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `Wymagane jest podanie harmonogramu pracy nr 3`,
    WORK_ORDER_TWO: `Harmonogram pracy 2`,
    WORK_REPAIR_ORDER: `Harmonogram prac naprawczych`,
    YES: `TAK`,
    YES_LOWERCASE: `Tak`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/pl.js